/**
 * Returns the depth of the given path in dot notation
 *
 * @param {string} value
 *
 * @return {number};
 */
export var depthOfPath = function (value) { return (value !== '' ? value.split('.').length : 0); };
//# sourceMappingURL=depthOfPath.js.map